/*
 * @Author: wangxiang
 * @Date: 2019-11-11 13:45:08
 * @Last Modified by: wangxiang
 * @Last Modified time: 2019-12-11 15:06:39
 */
function getComputedCSSText(style) {
  let cssText = '';

  for (let attr in style) {
    cssText += `${attr.replace(/[A-Z]+/g, m => `-${m.toLowerCase()}`)}:${style[attr]};`;
  }
  return cssText;
}

export default {
  methods: {
    async runAnimations() {
      const animationQueue = this.animations || this.element.animations || [];
      let len = animationQueue.length;

      if (len === 0) return false;

      let that = this;
      let parentNode = this.$el;
      let animIdx = 0;
      const oldStyle = this.element ? that.element.getStyle({ position: 'absolute' }) : {};

      runAnimation();

      function runAnimation() {
        if (animIdx < len) {
          const animation = animationQueue[animIdx];
          let animationStyle = {
            animationName: animation.type,
            animationDuration: `${animation.duration}s`,
            animationIterationCount: animation.infinite ? 'infinite' : animation.interationCount,
            animationDelay: `${animation.delay}s`,
            animationFillMode: 'both',
            transformOrigin: animation.transformOrigin || 'center',
            animationTimingFunction: animation.timingFunction || 'ease',
          };

          parentNode.style.cssText = getComputedCSSText(animationStyle) + getComputedCSSText(oldStyle);
          animIdx++;
        } else {
          parentNode.style.cssText = getComputedCSSText(oldStyle);
        }
      }
      parentNode.addEventListener('animationend', runAnimation, false);
    },
  },
  created() {
    const that = this;

    window.getEditorApp &&
      window.getEditorApp.$on('RUN_ANIMATIONS', () => {
        that.runAnimations();
      });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/animation.js